import { getPropertyValue } from '@tribeplatform/react-ui-kit/utils'

export const customizerPreviewScrollTo = (
  element: HTMLElement,
  document: Document,
) => {
  const offset =
    20 + parseInt(getPropertyValue(document, '--c-header-height'), 10)
  const { top } = element.getBoundingClientRect()
  /**
   * The return type of getRootNode() is a Node type but doesn't include defaultView.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const _window = (element.getRootNode() as any).defaultView
  const y = top + _window.pageYOffset - offset
  _window.scrollTo({ top: y, behavior: 'smooth' })
}
